import { render, staticRenderFns } from "./EmploymentSettings.vue?vue&type=template&id=6d12b45e"
import script from "./EmploymentSettings.vue?vue&type=script&lang=js"
export * from "./EmploymentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports